import React from 'react';
import classNames from 'classnames';
import { ContactModel } from '@/typings/models/Contact';
import { getContactInitials } from '@/utils/contacts';
import styles from './index.module.less';

type ContactAvatarProps = {
  contact?: Partial<ContactModel> | null;
  size?: 'small' | 'default' | 'large';
  /** A contact that doesn't exist yet: grey, with a question mark. */
  placeholder?: boolean;
  className?: string;
};

const ContactAvatar: React.FC<ContactAvatarProps> = ({
  contact,
  size = 'default',
  placeholder,
  className,
}) => (
  <span
    aria-hidden
    className={classNames(
      styles.avatar,
      styles[`avatar_${size}`],
      placeholder ? styles.tone_placeholder : styles.tone_person,
      className,
    )}
  >
    {placeholder ? '?' : getContactInitials(contact)}
  </span>
);

export default React.memo(ContactAvatar);
